import axiosInstance from '../../../helpers/axios';

const getQuizzesRequest = ({ featureId, lessonId } = {}) => {
  let query = '';
  if (featureId) query += `?feature_id=${featureId}`;
  if (lessonId) query += `${query ? '&' : '?'}lesson_id=${lessonId}`;
  return axiosInstance.get(`quiz/get_by_query${query}`);
};

const getQuizRequest = (quizId) => {
  return axiosInstance.get(`quiz/get_by_id?quiz_id=${quizId}`);
};

const postQuizRequest = (data) => {
  return axiosInstance.post('quiz/store', data);
};

const patchQuizRequest = ({ data, quizId }) => {
  return axiosInstance.patch(`quiz/${quizId}`, data);
};

const deleteQuizRequest = (quizId) => {
  return axiosInstance.delete(`quiz/${quizId}`);
};

export {
  getQuizzesRequest,
  getQuizRequest,
  postQuizRequest,
  patchQuizRequest,
  deleteQuizRequest,
};
